<script setup>
defineProps({
    show: Boolean
});
</script>

<template>
    <Transition name="modal">
        <div v-if="show" class="modal-overlay">
            <div class="modal-container">
                <div class="spinner-wrapper">
                    <div class="spinner"></div>
                </div>
                <h2 class="modal-title">Procesando pago</h2>
                <p class="modal-message">Por favor espere un momento...</p>
            </div>
        </div>
    </Transition>
</template>

<style scoped>
.modal-overlay {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.6);
    backdrop-filter: blur(4px);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10000;
    padding: 1rem;
}

.modal-container {
    background: white;
    border-radius: 24px;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
    width: 100%;
    max-width: 360px;
    padding: 3rem 2rem;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    animation: popIn 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

@keyframes popIn {
    from {
        opacity: 0;
        transform: scale(0.95);
    }

    to {
        opacity: 1;
        transform: scale(1);
    }
}

.spinner-wrapper {
    margin-bottom: 1.5rem;
    position: relative;
    width: 64px;
    height: 64px;
}

.spinner {
    width: 100%;
    height: 100%;
    border: 4px solid #e5e7eb;
    border-top-color: #6366f1;
    border-radius: 50%;
    animation: spin 1s linear infinite;
}

@keyframes spin {
    to {
        transform: rotate(360deg);
    }
}

.modal-title {
    font-size: 1.25rem;
    font-weight: 700;
    color: #1f2937;
    margin: 0 0 0.5rem;
}

.modal-message {
    color: #6b7280;
    font-size: 0.95rem;
    margin: 0;
}

/* Dark Mode Support */
@media (prefers-color-scheme: dark) {
    .modal-overlay {
        background: rgba(0, 0, 0, 0.8);
    }

    .modal-container {
        background: #1e293b;
    }

    .modal-title {
        color: #e2e8f0;
    }

    .modal-message {
        color: #94a3b8;
    }

    .spinner {
        border-color: #334155;
        border-top-color: #818cf8;
    }
}

:root[data-theme="dark"] {
    .modal-overlay {
        background: rgba(0, 0, 0, 0.8);
    }

    .modal-container {
        background: #1e293b;
    }

    .modal-title {
        color: #e2e8f0;
    }

    .modal-message {
        color: #94a3b8;
    }

    .spinner {
        border-color: #334155;
        border-top-color: #818cf8;
    }
}
</style>
